import { useMemo } from 'react';
import { AdjustmentType } from 'enums';
import { AdjustmentCategoryGridProps } from 'types';

export default function useAdjustmentType(type: AdjustmentType, adjustmentTypeMap: Map<AdjustmentType, AdjustmentCategoryGridProps>): AdjustmentType {
    return useMemo(
        () => {
            let foundCategory = AdjustmentType.CustomerDeduction;
            adjustmentTypeMap.forEach((gridProps, category) => {
                if (gridProps.adjustmentTypes.includes(type)) {
                    foundCategory = category;
                }
            })
            return foundCategory;
        },
        [type]
    );
}